export type TextOp = 'li' | 'eq';
export type NumOp = 'eq' | 'gt' | 'lt' | 'gte' | 'lte';

export const isTextOp = (s: string): s is TextOp => s === 'li' || s === 'eq';
export const isNumOp = (s: string): s is NumOp => s === 'eq' || s === 'gt' || s === 'lt' || s === 'gte' || s === 'lte';
